import styled from 'styled-components';

// CONSTANTS
import { KOURNIKOVA } from '@/constants/colors';

// UTILITY
import { breakpoints } from '@/utility/breakpoints';

export const Container = styled.div`
  .emmy-awards {
    &__hero {
      .hero {
        &__subtitle {
          color: ${KOURNIKOVA};
        }

        &__right-section {
          position: relative;
          display: flex;
          align-items: flex-end;
          justify-content: flex-end;

          ${breakpoints.down('xs')} {
            position: static;
          }

          .bg {
            height: 100%;
            position: absolute;
            top: 0;
            left: 0;

            ${breakpoints.down('xs')} {
              top: auto;
              left: -100px;
              bottom: 0;
              height: 420px;
            }
          }

          .image {
            ${breakpoints.down('sm')} {
              max-width: 100%;
            }

            ${breakpoints.down('xs')} {
              max-width: 165px;
              margin: 0 auto;
            }
          }
        }
      }
    }

    &__content {
      padding-top: 58px;
      padding-bottom: 80px;

      .page-content + .page-content,
      .page-content + .create-free-profile,
      .create-free-profile + .page-content {
        margin-top: 40px;
      }
    }

    &__description {
      max-width: 730px;
      margin-right: auto;
      margin-left: auto;
      margin-bottom: 45px;
    }

    &__collection {
      &:not(:first-of-type) {
        padding-top: 20px;
      }
      &:not(:last-of-type) {
        padding-bottom: 20px;
      }
    }
  }
`;

export default Container;
